import React, { Component } from 'react'
import moment from 'moment-timezone'

// CSS
import '../../css/display-table.css'

// Utils
import getFormattedAddress from '../../utils/reviews/addresses'

class SearchReviews extends Component {
	render() {
		// Use either id or some other index name passed as prop
		const indexUsed = this.props.index ? this.props.index : 'id'

		return (
			<React.Fragment>
				{this.props.items.length ? (
					<table className='display_table'>
						<thead>
							<tr className='table-header'>
								<th />
								<th>Organization</th>
								<th>Location</th>
								<th>Site Visit Starts</th>
								<th />
							</tr>
						</thead>
						<tbody>
							{this.props.items.map((item, i) => (
								<tr
									className='clickable'
									key={i}
									onClick={() =>
										this.props.history.push(this.props.basePath + '/' + item[indexUsed])
									}
								>
									<td className='record-number'>{i + this.props.startPosition + 1}</td>
									<td data-id='Organization'>{item.organization_title}</td>
									<td data-id='Location'>{getFormattedAddress(item)}</td>
									<td data-id='Site Visit Starts'>
										{moment.utc(item.site_visit_starts).format('MMM D, Y')}
									</td>
									<td className='edit-cell'>
										<div className='edit_btn'>Edit</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div>No Results</div>
				)}
			</React.Fragment>
		)
	}
}

SearchReviews.defaultProps = {
	items: [],
	startPosition: 0,
	clickHandle: null,
}

export default SearchReviews



// WEBPACK FOOTER //
// ./src/components/search/SearchReviews.js